import { render, staticRenderFns } from "./BgTag.vue?vue&type=template&id=52d642f0&scoped=true"
import script from "./BgTag.vue?vue&type=script&lang=js"
export * from "./BgTag.vue?vue&type=script&lang=js"
import style0 from "./BgTag.vue?vue&type=style&index=0&id=52d642f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d642f0",
  null
  
)

export default component.exports